export const Dropdown = {

    dropdown: `

    `,
};

export default Dropdown;